import {Component, attr} from "../Component";
import {element} from "../CustomElement";

interface FitImageProps extends JSX.HTMLProps {
	href: string;
}

// Public Definitions -------------------------------------------------------->

@element("flipp-fit-img", "img")
export class FitImageElement extends Component<FitImageProps, {}> {

	@attr href: string;

	render() {
		const src = this.href;
		const objectFit = this.style.hasOwnProperty("objectFit") &&
				this.style.hasOwnProperty("objectPosition");

		if (objectFit) {
			this.setAttribute("src", src);
		} else {
			this.setAttribute("src", "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=");
			this.setAttribute("style", `background-image: url(${src})`);
		}

		return null as JSX.Element;
	}
}
